import {useDebugValue} from 'react';

import {getKeyedObject, getNoUndefValuesObject} from '../../../utils/object';
import {getNoUndefValuesArray} from '../../../utils/array';

function useStoreData(config, defaultStore, otherStores) {
    const {
        storeDataRef,
        storeKeys
    } = config;

    const {
        [storeDataRef]: defaultData,
    } = defaultStore;

    const otherData = getNoUndefValuesArray(otherStores.map((store) => (
        store[storeDataRef]
    )));

    const specifiedData = otherData.reduce((accumulatedData, currentData) => ({
        ...accumulatedData,
        ...getNoUndefValuesObject(currentData)
    }), {});

    const storeData = getKeyedObject({
        ...defaultData,
        ...specifiedData
    }, storeKeys);

    const result = {
        storeData
    };

    useDebugValue(result);

    return result;
}

export {useStoreData};
